<template>
    <div class="base-dialog-wrap" v-if="visible">
        <div class="base-dialog">
            <div class="base-dialog-title">
                <h3 class="display-4">温馨提示</h3>
                <!-- 实际上不写参数 false也可以，因为默认值就是false 或者undefined -->
                <button class="btn-close" @click="$emit('update:visible')">x</button>
            </div>
            <div class="base-dialog-content">
                <p>您确认要退出么？</p>
            </div>
            <div class="base-dialog-footer">
                <button class="btn btn-primary" @click="$emit('update:visible', false)">确定</button>
                <button class="btn btn-secondary" @click="$emit('update:visible', false)">取消</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BaseDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>
.base-dialog-wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.base-dialog {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.base-dialog-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.base-dialog-content {
    margin-top: 20px;
}

.base-dialog-footer {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
}
</style>